import { SVGProps } from 'react';
import { twMerge } from 'tailwind-merge';


export default function PollIcon(props: Partial<SVGProps<any>>) {
  return (
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} className={twMerge('mb-[6px]', props.className)}>
  <path d="M7.99972 14.2857C11.7864 14.2857 14.8569 11.4712 14.8569 8.00001C14.8569 4.52877 11.7864 1.71429 7.99972 1.71429C4.21305 1.71429 1.14258 4.52877 1.14258 8.00001C1.14258 9.60306 1.79705 11.0652 2.87439 12.1752C3.20353 12.5158 3.4382 12.9676 3.32086 13.4255C3.19238 13.9262 2.95193 14.3913 2.61763 14.7855C2.88516 14.8336 3.15647 14.8576 3.42829 14.8572C4.40505 14.8572 5.3102 14.5509 6.05305 14.029C6.6702 14.1966 7.32391 14.2857 7.99972 14.2857Z" stroke="#212021" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
  )
}